import { eventRef } from './eventRef';
// Links an event exposes (on-spot form, desk, scan purposes) plus admin-added ones, for the QR PDF.
const STORAGE_KEY = (eventId) => `eventQrPdf:${eventId}`;

export function eventQrLinks(eventId, purposes = [], origin = window.location.origin) {
  return [
    { key: 'onspot', label: 'On-spot registration', url: `${origin}/register/${eventRef(eventId)}/on-spot?enableCta=true` },
    { key: 'desk', label: 'Kiosk / Desk', url: `${origin}/desk/${eventRef(eventId)}` },
    ...purposes.filter((p) => p?.purpose).map((p) => ({
      key: `purpose:${p.purpose}`,
      label: p.name || p.purpose,
      url: `${origin}/admin/events/${eventRef(eventId)}/scan?purpose=${encodeURIComponent(p.purpose)}`,
    })),
  ];
}

// Exclusions are remembered rather than inclusions, so purposes added later are included by default.
export function loadQrPdfSettings(eventId) {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY(eventId)) || '{}');
    return {
      excluded: Array.isArray(saved.excluded) ? saved.excluded : [],
      overrides: saved.overrides && typeof saved.overrides === 'object' ? saved.overrides : {},
      customLinks: Array.isArray(saved.customLinks) ? saved.customLinks : [],
      showUrl: saved.showUrl !== false,
    };
  } catch (_) {
    return { excluded: [], overrides: {}, customLinks: [], showUrl: true };
  }
}

export function saveQrPdfSettings(eventId, settings) {
  try {
    localStorage.setItem(STORAGE_KEY(eventId), JSON.stringify(settings));
  } catch (_) { /* storage unavailable */ }
}

export const isValidLink = (url) => /^https?:\/\/\S+$/i.test(String(url || '').trim());

/** A built-in link with the admin's edited heading/URL applied (blank edits fall back to the default). */
export function applyOverride(link, overrides = {}) {
  const edit = overrides[link.key] || {};
  return {
    ...link,
    label: String(edit.label || '').trim() || link.label,
    url: isValidLink(edit.url) ? edit.url.trim() : link.url,
    edited: !!(String(edit.label || '').trim() || isValidLink(edit.url)),
  };
}

/** Pages for the PDF, in display order: built-in links not excluded, then complete custom links. */
export function selectedQrPages(links, settings) {
  const builtIn = links
    .filter((link) => !settings.excluded.includes(link.key))
    .map((link) => applyOverride(link, settings.overrides));
  const custom = settings.customLinks
    .filter((link) => link.included !== false && String(link.label || '').trim() && isValidLink(link.url))
    .map((link) => ({ key: link.id, label: link.label.trim(), url: link.url.trim() }));
  return [...builtIn, ...custom];
}
